import React from 'react'
import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Line
} from 'recharts'
import { format as formatDate } from 'date-fns'
import { useTheme } from '@mui/material'

import BodyWidget from '../../../../../components/atoms/BodyWidget'
import LoadingSpinner from '../../../../../components/atoms/LoadingSpinner'

import { useStats } from '../../../../../providers/StatsProvider'
import useStyles from './styles'

const ConversationsPerDay = () => {
  const theme = useTheme()

  const { chatStats, chatLoaded } = useStats()

  const data = React.useMemo(() => chatStats?.timeseries ?? [], [chatStats])
  const formattedData = React.useMemo(() => {
    const sorted = data.sort((a, b) => +new Date(a.date) - +new Date(b.date))
    const mapped = sorted.map(({ date, value }) => ({
      date: formatDate(new Date(date), 'MMM dd'),
      value
    }))
    return mapped
  }, [data])

  const classes = useStyles()

  const formatTooltip = React.useCallback(
    value => [<div className={classes.tooltipValue}>{value}</div>, ''],
    [classes.tooltipValue]
  )

  return (
    <BodyWidget title='New Conversations Per Day' className={classes.root}>
      {!chatLoaded ? (
        <LoadingSpinner />
      ) : (
        <ResponsiveContainer height={250} width='92.5%'>
          <LineChart
            data={formattedData}
            margin={{ top: 5, right: 5, bottom: 5, left: 15 }}
          >
            <XAxis dataKey='date' fontSize={theme.size.sm} />

            <YAxis fontSize={theme.size.sm} />

            <Tooltip
              separator=''
              formatter={formatTooltip}
              wrapperStyle={{ outline: 'none' }}
            />

            <Line
              type='monotone'
              dataKey='value'
              stroke={theme.palette.primary.main}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </BodyWidget>
  )
}

export default ConversationsPerDay
